// The guided tour of Contact Details, the first of the four My Info pages.
//
// Each My Info page has its own tour rather than sharing one, because each
// has its own address and its own arrival: somebody following the leave
// approval email lands on Leave & Holidays and has never seen this page. The
// engine (shared/FeatureTour.jsx) and the show-once record
// (hooks/useFeatureTour.js) are generic; only this file knows about contact
// details. Steps point at [data-tour] anchors on people/MyInfoPage.jsx.

export const MY_CONTACT_TOUR_ID = 'my-contact';

export const myContactTourSteps = [
  {
    title: 'Welcome to My Info',
    body: [
      'Your own record lives under My Info in the sidebar: My Contact Details, My Leave & Holidays, My Benefits, My Overtime, My Company Card and My Time. The first four each have a short tour like this one, and each opens once.',
      'This one covers what HR holds about you and what you can change yourself. Use Next (or the arrow keys) to walk through, or Skip if you would rather explore.',
    ],
  },
  {
    title: 'What HR holds',
    target: '[data-tour="contact-hr-fields"]',
    body: [
      'Your name, work email, role and team come from your People record and are read-only here. If one of them is wrong, speak to HR rather than looking for a box to edit.',
    ],
  },
  {
    title: 'Your details, changed any time',
    target: '[data-tour="contact-your-details"]',
    body: [
      'Preferred name, personal email, phone numbers, home address and emergency contact are yours to keep current. There is no approval to wait for.',
      'The emergency contact is the one worth checking now: it is the number somebody will reach for on a bad day, and it is easy to leave it pointing at an old one.',
    ],
  },
  {
    title: 'Save, and HR is told',
    target: '[data-tour="contact-save"]',
    body: [
      'Save Changes writes straight to your record. HR is notified of what changed so their file matches, which is why there is nothing to approve: the change is already made.',
    ],
  },
  {
    title: 'That\'s this page',
    body: [
      'The other three My Info pages are one click away in the sidebar, and each has its own tour. To see this one again, the "?" beside the page title replays it.',
    ],
  },
];
